import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Globe, Zap } from 'lucide-react';
export function MarketSlide() {
  return <div className="h-full flex flex-col" data-id="element-211">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full items-center" data-id="element-212">
        <div className="space-y-8" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="flex items-start gap-4" data-id="element-214">
            <div className="p-3 rounded-xl bg-blue-50 text-blue-600" data-id="element-215">
              <Globe className="w-6 h-6" data-id="element-216" />
            </div>
            <div data-id="element-217">
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-218">
                $100B Blue Ocean
              </h3>
              <p className="text-gray-500" data-id="element-219">
                Healthcare's unique barriers make this a protected vertical.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="flex items-start gap-4" data-id="element-220">
            <div className="p-3 rounded-xl bg-green-50 text-green-600" data-id="element-221">
              <TrendingUp className="w-6 h-6" data-id="element-222" />
            </div>
            <div data-id="element-223">
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-224">
                25% YoY Growth
              </h3>
              <p className="text-gray-500" data-id="element-225">
                Explosive demand for outcome/SaS models.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="flex items-start gap-4" data-id="element-226">
            <div className="p-3 rounded-xl bg-purple-50 text-purple-600" data-id="element-227">
              <Zap className="w-6 h-6" data-id="element-228" />
            </div>
            <div data-id="element-229">
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-230">
                Perfect Inflection
              </h3>
              <p className="text-gray-500" data-id="element-231">
                SaaS reset + agentic AI maturity = NOW.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="relative h-[400px] rounded-3xl border border-blue-100 flex flex-col items-center justify-center overflow-hidden" style={{
        background: 'linear-gradient(180deg, #EFF6FF 0%, #DBEAFE 40%, #93C5FD 75%, #3B82F6 100%)'
      }} data-id="element-232">
          {/* Animated waves */}
          <svg className="absolute bottom-0 left-0 w-full" viewBox="0 0 500 120" preserveAspectRatio="none" style={{
          height: '45%'
        }} data-id="element-233">
            <motion.path d="M0 60 Q 60 30, 125 55 T 250 50 T 375 55 T 500 45 L 500 120 L 0 120 Z" fill="rgba(59, 130, 246, 0.25)" animate={{
            d: ['M0 60 Q 60 30, 125 55 T 250 50 T 375 55 T 500 45 L 500 120 L 0 120 Z', 'M0 50 Q 60 70, 125 45 T 250 55 T 375 40 T 500 55 L 500 120 L 0 120 Z', 'M0 60 Q 60 30, 125 55 T 250 50 T 375 55 T 500 45 L 500 120 L 0 120 Z']
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-234" />
            <motion.path d="M0 75 Q 80 55, 150 70 T 300 65 T 450 72 T 500 60 L 500 120 L 0 120 Z" fill="rgba(59, 130, 246, 0.35)" animate={{
            d: ['M0 75 Q 80 55, 150 70 T 300 65 T 450 72 T 500 60 L 500 120 L 0 120 Z', 'M0 65 Q 80 80, 150 62 T 300 72 T 450 60 T 500 70 L 500 120 L 0 120 Z', 'M0 75 Q 80 55, 150 70 T 300 65 T 450 72 T 500 60 L 500 120 L 0 120 Z']
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5
          }} data-id="element-235" />
            <motion.path d="M0 90 Q 100 75, 200 85 T 400 82 T 500 78 L 500 120 L 0 120 Z" fill="rgba(37, 99, 235, 0.45)" animate={{
            d: ['M0 90 Q 100 75, 200 85 T 400 82 T 500 78 L 500 120 L 0 120 Z', 'M0 82 Q 100 92, 200 78 T 400 88 T 500 82 L 500 120 L 0 120 Z', 'M0 90 Q 100 75, 200 85 T 400 82 T 500 78 L 500 120 L 0 120 Z']
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} data-id="element-236" />
          </svg>

          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="relative z-10 text-center" data-id="element-237">
            <div className="text-6xl font-bold text-blue-900 mb-4" data-id="element-238">10x</div>
            <div className="text-xl text-blue-800/70 mb-8" data-id="element-239">
              Returns in 3-5 Years
            </div>

            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 backdrop-blur-sm border border-blue-200 text-blue-700 text-sm font-medium shadow-sm" data-id="element-240">
              <TrendingUp className="w-4 h-4" data-id="element-241" />
              20x+ ARR Multiples
            </div>
          </motion.div>

          {/* Blue ocean label */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="absolute bottom-4 right-4 text-xs font-mono text-blue-400/60 tracking-wider" data-id="element-242">
            BLUE OCEAN
          </motion.div>
        </div>
      </div>
    </div>;
}